import { observer } from 'mobx-react-lite';
import { useLayoutEffect, useState } from 'react';

import { Button, Header, Input, Message, Modal } from 'semantic-ui-react';
import { Activity } from '../../../models/activity';
import { useStore } from '../../../stores/store';
import { userLanguage } from '../../userLanguageSchema/userLanguage';

interface Props {
  activityid: string;
  rfidValue: string | undefined;
}

function RfidScannerModal({ activityid, rfidValue }: Props) {
  const { dashboardStore, activityStore, commonStore } = useStore();
  const { activityRegistryrfid } = activityStore;
  const [, setOpen] = useState(false);
  const [errorState, setErrorState] = useState('');

  useLayoutEffect(() => {
    let element = document.getElementById('scanRFID');
    if (element) {
      element.focus();
    }
  }, []);

  const handleChange = (event: any) => {
    const rfidData = event.target.value;

    if (rfidData !== activityid || rfidData !== rfidValue) {
      const existData: Activity | undefined =
        activityRegistryrfid.get(rfidData);

      if (!existData) {
        setErrorState('');
        // setResult(data);
        dashboardStore.setRfidValue(event.target.value);
      }
      if (existData) setErrorState('Data Already Exist');
    } else {
      setErrorState('Same Data Detected');
    }
  };

  const handleSave = () => {
    dashboardStore.setOpenRfidScanner(false);
  };
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboardStore.dashboard.openRfidScanner}
    >
      <Modal.Header
      //Rfid
      >
        {
          (
            userLanguage[0].Level3InventoryRecievingTagScanRFIDModal
              ?.IRTSRFL01 as any
          )?.[`${commonStore.language.key}`]
        }
      </Modal.Header>
      <Modal.Content>
        <Header
        //Enter or Scan Rfid
        >
          {
            (
              userLanguage[0].Level3InventoryRecievingTagScanRFIDModal
                ?.IRTSRFL02 as any
            )?.[`${commonStore.language.key}`]
          }
        </Header>
        <Input
          id={'scanRFID'}
          placeholder={
            (
              userLanguage[0].Level3InventoryRecievingTagScanRFIDModal
                ?.IRTSRFTB01 as any
            )?.[`${commonStore.language.key}`]
          } //'rfid'
          name="Rfid"
          fluid
          onChange={handleChange}
          value={dashboardStore.dashboard.getRfidValue}
        />
        {errorState.length > 0 && (
          <Message negative>
            <Message.Header>{errorState}</Message.Header>
          </Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => dashboardStore.setOpenRfidScanner(false)}
          //Cancel
        >
          {' '}
          {
            (
              userLanguage[0].Level3InventoryRecievingTagScanRFIDModal
                ?.IRTSRFB01 as any
            )?.[`${commonStore.language.key}`]
          }{' '}
        </Button>
        <Button
          //content="Save"
          content={
            (
              userLanguage[0].Level3InventoryRecievingTagScanRFIDModal
                ?.IRTSRFB02 as any
            )?.[`${commonStore.language.key}`]
          }
          labelPosition="right"
          icon="checkmark"
          onClick={handleSave}
          positive
          disabled={errorState.length > 0 ? true : false}
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(RfidScannerModal);
